<template>
    <div style="width: 100%;position: relative;padding-top: 30px;background:#ffffff;margin-bottom: 100px;">
        <img src="../../assets/images/Background4.png"
            style="position: absolute;width: 100%;top: 0px;left: 0px;box-shadow:rgb(244 244 244) 0px 500px 500px 500px;opacity: 0.5;">
        <div style="position: relative;">
            <div class="file" style="width: 1200px;margin: 0px auto;align-items: self-start;">
                <div
                    style="width: 300px;background: #fff;border-radius: 20px;padding:40px 20px 55px 20px;box-shadow:rgba(176, 176, 176, 0.5) 0px 6px 10px 0px;">
                    <div>
                        <img :src="action + data.logo" style="margin: 0px auto;">
                    </div>
                    <div class="cprimary"
                        style="margin-top: 40px;font-size: 18px;font-weight: bold;text-align: center;">{{ data.titleb }}
                    </div>
                    <div style="margin-top: 40px;font-size: 14px;padding: 0px 18px;line-height: 30px;">
                        {{ data.textb }}
                    </div>
                    <div v-if="data.products.length > 0"
                        style="margin-top: 38px;background: #f5f5f5;font-size: 14px;padding: 19px;border-radius: 20px;"
                        class="file">
                        <div style="font-weight: bold;">
                            使用产品：
                        </div>
                        <div style="color: #1e66d1;">
                            <div v-for="(x, i) in data.products" :style="'margin-top:' + (i == 0 ? '' : '13px;')">{{
                                x.name }}
                            </div>
                        </div>
                    </div>
                    <!-- <div style="margin-top: 50px;">
                        <div @click="to('contactForm')"
                            style="cursor: pointer; width: 200px;height: 40px;line-height: 40px;color: #fff;background: #1e66d1;font-size: 16px;text-align: center;margin: 0px auto;border-radius: 20px;">
                            获取详细解决方案 >
                        </div>
                    </div> -->
                </div>
                <div style="padding-left:80px;flex: 1;">
                    <div>
                        <div><img :src="action + data.imgb" style="width: 500px;height: 200px;border-radius: 20px;">
                        </div>
                    </div>
                    <div style="margin-top: 45px;">
                        <div class="file falign">
                            <div style="font-size: 24px;color: #1e66d1;">◆</div>
                            <div style="font-size: 18px;font-weight: bold;margin-left: 15px;">业务挑战</div>
                        </div>
                        <div style="margin-top: 20px;">
                            <div v-for="(x, i) in data.business">
                                <div style="font-size: 14px;font-weight: bold;">{{ x.title }}</div>
                                <div style="font-size: 14px;margin-top: 10px;margin-bottom: 30px;">
                                    {{ x.text }}</div>
                            </div>
                        </div>
                    </div>
                    <div style="margin-top: 50px;">
                        <div class="file falign">
                            <div style="font-size: 24px;color: #1e66d1;">◆</div>
                            <div style="font-size: 18px;font-weight: bold;margin-left: 15px;">解决方案：{{ data.ptitle }}
                            </div>
                        </div>
                        <div style="margin-top: 20px;font-size: 14px;line-height: 25px;">
                            {{ data.ptext }}
                        </div>
                    </div>
                    <div style="margin-top: 50px;margin-bottom: 20px;">
                        <div class="file falign">
                            <div style="font-size: 24px;color: #1e66d1;">◆</div>
                            <div style="font-size: 18px;font-weight: bold;margin-left: 15px;">客户价值</div>
                        </div>
                        <div style="margin-top: 20px;margin-left: 5px;font-size: 14px;line-height: 25px;">
                            {{ data.crmprice }}
                        </div>
                    </div>
                    <div style="margin-top: 50px;margin-bottom: 0px;" v-if="data.imgsx || data.imgs">
                        <div class="file falign">
                            <div style="font-size: 24px;color: #1e66d1;">◆</div>
                            <div style="font-size: 18px;font-weight: bold;margin-left: 15px;">功能展示</div>
                        </div>
                    </div>
                    <div class="file"
                        style="margin-left: 5px;width: 100%;flex-wrap: wrap;justify-content: space-between;">
                        <div v-for="(x, i) in data.imgsx" style="width: 31%;">
                            <div
                                style="box-shadow:rgba(176, 176, 176, 0.5) 0px 3px 20px 1px;width: 100%;height: auto;margin-top: 30px;">
                                <img style="width: 100%;height: auto;" :src="action + x">
                            </div>
                            <!-- <div style="font-size: 14px;text-align: center;margin-top: 20px;">{{ data.imgstext[i] }}</div> -->
                        </div>
                    </div>
                    <div style="margin-left: 5px;width: 100%;flex-wrap: wrap;">
                        <div v-for="(x, i) in data.imgs" style="margin-top: 50px;">
                            <div style="box-shadow:rgba(176, 176, 176, 0.5) 0px 3px 20px 1px;height: auto;width: 100%;">
                                <img style="max-width: 100%;height: auto;" :src="action + x">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="position:fixed;top: 45%;right: 50px;opacity: 0.3;">
                <div @click="nextClick"
                    style="width: 40px;height: 40px;background-color: rgb(69 121 198);border-radius: 50%;color: #fff;text-align: center;line-height:36px;font-size: 32px;font-weight: normal;margin-right: 20px;cursor: pointer;">
                    ></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            action: window['pathConfig'][process.env.NODE_ENV].ImgURL,
            data: {},
            arr: [],
            index: 0
        }
    },
    created() {
    },
    activated() {
        var arr = []
        this.index = Number(this.$route.query.index)
        this.$http("/CrmCase/GetDetails", { menuid: this.$route.query.id }).then((x) => {
            if (x.length > 0) {
                x.forEach((x, i) => {
                    if (i < 3) {
                        arr.push(x.typeid)
                    }
                })
                this.arr = arr
                this.load(arr[this.index])
            }
        });
    },
    methods: {
        to(name) {
            this.$router.push({ name: name })
        },
        nextClick() {
            if (this.index == 2)
                this.index = 0
            else
                this.index++
            this.load(this.arr[this.index])
        },
        load(id) {
            console.log(id)
            this.$http('/CrmCase/GetDetails', { typeid: id }).then(x => {
                if (x.length > 0) {
                    this.data = x[0]
                    if (x[0].imgs) this.data.imgs = x[0].imgs.split(',')
                    if (x[0].imgsx) this.data.imgsx = x[0].imgsx.split(',')
                }
            })
        }
    }
}
</script>
